export default __webpack_public_path__ + "static/media/07.075651d4.jpg";